/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_AutopilotsInputs */

const en_mk_mx_autopilots = /** @type {(inputs: Mk_Mx_AutopilotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled routines`)
};

const id_mk_mx_autopilots = /** @type {(inputs: Mk_Mx_AutopilotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutinitas terjadwal`)
};

/**
* | output |
* | --- |
* | "Scheduled routines" |
*
* @param {Mk_Mx_AutopilotsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_autopilots = /** @type {((inputs?: Mk_Mx_AutopilotsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_AutopilotsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_autopilots(inputs)
	return en_mk_mx_autopilots(inputs)
});